import React from 'react';
import { FDBox, FDPaper } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import GradientSection from 'Components/ComponentLibrary/Organisms/WhatIfClientScenarioDetails/GradientSection';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';

const useStyles = buildUseStyles('ScenarioSelectionChartsLayout', () => ({
  flexiblePaper: {
    '& .FD-MuiPaper-root': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
}));

const ScenarioSelectionChartsLayout = () => {
  const { resource } = useMetaLayoutContext();
  const classes = useStyles();
  const isMobile = useMobileLayout();

  return (
    <FDBox>
      <FDBox paddingY={4}>
        <MetaControlField attr={'title'} />
      </FDBox>
      <FDBox>
        <div className={classes.flexiblePaper}>
          <FDPaper
            appearance={'elevated'}
            padding={'400'}
            // On mobile the legend can take up a lot more space, so we need more space for the chart.
            // Normally we shouldn't need to do this, but there's a recharts bug causing this: https://github.com/recharts/recharts/issues/6245
            minHeight={isMobile ? '700px' : '600px'}
          >
            <GradientSection
              height={400}
              flex={1}
              facetPlanClientViewResource={resource}
              isMultiChart
            />
          </FDPaper>
        </div>
      </FDBox>
    </FDBox>
  );
};

ScenarioSelectionChartsLayout.defaultProps = {};

ScenarioSelectionChartsLayout.propTypes = {};

export default ScenarioSelectionChartsLayout;
